export default "__VITE_ASSET__BSWXzyl3__"